export const limitDefaultTilesPerLine = 20

export const channelSlidersCountInPortView = 4.11
export const focusedChannelTileScale = 1.08

export const smartPreviewSlidersCountInPortView = 3.2

export const eventSliderLogoWidth = 150
export const channelSliderImgWidth = 200
export const sportCategoryIconWidth = 280
export const eventSliderImgWidth = { classic: 384, large: 802, square: 200 }

export const boxWidth = 384
export const boxHeight = 216
export const focusedGridTileScale = 1.1
